(function () {
  'use strict';

  var EXPLICIT_MAX = 5;
  var DUO_TRIO_MAX = 2;
  var SECRET_MAX = 1;

  var SECRET_HANDLES = [
    'secret-sale-nad-peptide-boosting-trio',
    'secret-sale-vitamin-illuminating-routine-set',
    'secret-sale-nad-peptide-boosting-routine-set',
    'secret-10-off-nad-peptide-boosting-routine-set',
    'secret-10-off-vitamin-illuminating-routine-set'
  ];

  var SECRET_TITLES = [
    '[Secret Sale\u{1F512}] NAD+ Peptide Boosting Trio',
    '[Secret Sale\u{1F512}] Vitamin illuminating Routine Set',
    '[Secret Sale\u{1F512}] NAD+ Peptide Boosting Routine Set',
    '[Secret 10% OFF] NAD+ Peptide Boosting Routine Set',
    '[Secret 10% OFF] Vitamin illuminating Routine Set'
  ];

  var EXPLICIT_HANDLES = [
    'vitamin-illuminating-serum',
    'vitamin-illuminating-cream',
    'nad-peptide-boosting-serum',
    'nad-peptide-boosting-cream'
  ];

  var EXPLICIT_TITLES = [
    'Vitamin illuminating Serum',
    'Vitamin illuminating Cream',
    'NAD+ Peptide Boosting Serum',
    'NAD+ Peptide Boosting Cream'
  ];

  var INC_SEL = '.corner-cowi-cart-item-customiser-qty-increase';
  var DEC_SEL = '.corner-cowi-cart-item-customiser-qty-decrease';
  var QTY_BOX_SEL = '.corner-cowi-cart-item-qty';
  var QTY_INPUT_SEL = 'input[id^="corner-cowi-cart-item-qty-input"]';
  var BLOCK_CLASS = 'eqb-qty-blocked';

  function norm(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function loose(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  var explicitTitles = Object.create(null);
  EXPLICIT_TITLES.forEach(function (t) { explicitTitles[norm(t)] = true; });
  var secretTitles = Object.create(null);
  SECRET_TITLES.forEach(function (t) { secretTitles[loose(t)] = true; });
  var configTitles = Object.create(null);
  var configHandles = Object.create(null);
  var CONFIG_RULES = (window.eqbPurchaseLimits && window.eqbPurchaseLimits.rules) || [];
  CONFIG_RULES.forEach(function (r) {
    var max = Number(r.max);
    if (!max) return;
    if (r.title) configTitles[loose(r.title)] = max;
    if (r.handle) configHandles[r.handle] = max;
  });
  var cartQtyByTitle = Object.create(null);

  function limitForTitle(title) {
    var t = norm(title);
    if (!t) return null;
    var lt = loose(title);
    var limits = [];
    if (secretTitles[lt]) limits.push(SECRET_MAX);
    if (configTitles[lt]) limits.push(configTitles[lt]);
    if (explicitTitles[t]) limits.push(EXPLICIT_MAX);
    if (t.indexOf('duo') !== -1 || t.indexOf('trio') !== -1) limits.push(DUO_TRIO_MAX);
    return limits.length ? Math.min.apply(null, limits) : null;
  }

  function titleOf(btn) {
    var d = btn.getAttribute('aria-description') || '';
    return d.replace(/^\s*(increase|decrease)\s+quantity\s+of\s+/i, '');
  }

  function limitForBtn(btn) {
    return limitForTitle(titleOf(btn));
  }

  function titleOfInput(inp) {
    var a = inp.getAttribute('aria-label') || '';
    return a.replace(/^\s*(increase|decrease)?\s*quantity\s+of\s+/i, '');
  }

  function clampInput(inp) {
    if (!inp) return;
    var limit = limitForTitle(titleOfInput(inp));
    if (limit == null) return;
    var digits = String(inp.value || '').replace(/[^\d]/g, '');
    if (!digits) return;
    var n = parseInt(digits, 10);
    if (isNaN(n)) return;
    if (n > limit) {
      inp.value = String(limit);
      try {
        inp.setSelectionRange(inp.value.length, inp.value.length);
      } catch (e) {}
    }
  }

  function inputFrom(e) {
    var tgt = e.target;
    if (!tgt || !tgt.closest) return null;
    return tgt.closest(QTY_INPUT_SEL);
  }

  function readQty(incBtn) {
    var el = incBtn.previousElementSibling;
    if (el) {
      var m = (el.textContent || '').match(/\d+/);
      if (m) return parseInt(m[0], 10);
    }
    var box = incBtn.closest(QTY_BOX_SEL) || incBtn.parentElement;
    if (box) {
      var kids = box.querySelectorAll('*');
      for (var i = 0; i < kids.length; i++) {
        if (!kids[i].children.length) {
          var mm = (kids[i].textContent || '').trim().match(/^\d+$/);
          if (mm) return parseInt(mm[0], 10);
        }
      }
    }
    var cached = cartQtyByTitle[norm(titleOf(incBtn))];
    return (typeof cached === 'number') ? cached : null;
  }

  function setBlocked(btn, on) {
    if (on) {
      btn.classList.add(BLOCK_CLASS);
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.classList.remove(BLOCK_CLASS);
      btn.removeAttribute('aria-disabled');
    }
  }

  function apply() {
    var incs = document.querySelectorAll(INC_SEL);
    for (var i = 0; i < incs.length; i++) {
      var btn = incs[i];
      var limit = limitForBtn(btn);
      if (limit == null) { setBlocked(btn, false); continue; }
      var q = readQty(btn);
      setBlocked(btn, (q != null && q >= limit));
    }
  }

  function syncCart() {
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          cartQtyByTitle = Object.create(null);
          cart.items.forEach(function (it) {
            if (EXPLICIT_HANDLES.indexOf(it.handle) !== -1) {
              explicitTitles[norm(it.product_title)] = true;
            }
            if (SECRET_HANDLES.indexOf(it.handle) !== -1) {
              secretTitles[loose(it.product_title)] = true;
            }
            if (configHandles[it.handle]) {
              configTitles[loose(it.product_title)] = configHandles[it.handle];
            }
            if (limitForTitle(it.product_title) != null) {
              var k = norm(it.product_title);
              cartQtyByTitle[k] = (cartQtyByTitle[k] || 0) + it.quantity;
            }
          });
          apply();
        })
        .catch(function () {});
    } catch (e) {}
  }

  var syncTimer = null;
  function scheduleSync() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { syncTimer = null; syncCart(); }, 400);
  }

  document.addEventListener('click', function (e) {
    var tgt = e.target;
    if (!tgt || !tgt.closest) return;
    var inc = tgt.closest(INC_SEL);
    if (inc) {
      var limit = limitForBtn(inc);
      if (limit != null) {
        var q = readQty(inc);
        if (q != null && q >= limit) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          setBlocked(inc, true);
          return;
        }
      }
    }
    if (inc || tgt.closest(DEC_SEL)) scheduleSync();
  }, true);

  ['input', 'change', 'blur', 'paste', 'drop'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var inp = inputFrom(e);
      if (!inp) return;
      if (evt === 'paste' || evt === 'drop') {
        setTimeout(function () { clampInput(inp); }, 0);
        return;
      }
      clampInput(inp);
      if (evt === 'change' || evt === 'blur') scheduleSync();
    }, true);
  });

  document.addEventListener('keydown', function (e) {
    var inp = inputFrom(e);
    if (!inp) return;
    if (e.key === 'Enter') {
      clampInput(inp);
      scheduleSync();
      return;
    }
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (e.key && e.key.length !== 1) return;
    if (!/^[0-9]$/.test(e.key)) return;
    var limit = limitForTitle(titleOfInput(inp));
    if (limit == null) return;
    var cur = String(inp.value || '');
    var start = inp.selectionStart == null ? cur.length : inp.selectionStart;
    var end = inp.selectionEnd == null ? cur.length : inp.selectionEnd;
    var next = (cur.slice(0, start) + e.key + cur.slice(end)).replace(/[^\d]/g, '');
    if (next && parseInt(next, 10) > limit) {
      e.preventDefault();
      if (e.stopPropagation) e.stopPropagation();
    }
  }, true);

  var rafId = null;
  var observer = new MutationObserver(function () {
    if (rafId) return;
    rafId = requestAnimationFrame(function () { rafId = null; apply(); });
  });

  function start() {
    apply();
    syncCart();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
